import React from 'lib/react';
import {
  EVSearch,
} from 'lib/components';
import PropTypes from 'prop-types';

/** Component to render input field with list of added values as chips */
function ChipInput(props) {
  const {
    inputValue, value, onInputChange, onAddValue, onDeleteValue, onClear, disableClearable, ...rest
  } = props;

  const handleChange = (_, list, type, ...params) => {
    if (type === 'create-option') onAddValue(list, ...params);
    else if (type === 'remove-option') onDeleteValue(list, ...params);
    else if (type === 'clear' && !disableClearable && onClear) onClear(list, ...params);
  };

  const addInputValueToValues = () => inputValue && onAddValue([...value, inputValue]);

  const handleKeyDown = (event) => {
    if (event.key === ' ') {
      event.preventDefault();
      addInputValueToValues();
    }
  };

  return (
    <EVSearch
      multiple
      disablePortal
      value={value}
      inputValue={inputValue}
      onInputChange={onInputChange}
      enableEnterOnCustomSearch
      // hides autocomplete suggestions
      renderOption={() => null}
      onChange={handleChange}
      noAutoSuggestResultMessage={{}}
      selectedLayer={{}}
      searchInputProps={{ autoFocus: true }}
      disableClearable={disableClearable}
      onKeyDown={handleKeyDown}
      onBlur={addInputValueToValues}
      {...rest}
    />
  );
}

ChipInput.defaultProps = {
  disableClearable: false,
  onClear: null,
};

ChipInput.propTypes = {
  /**
   * value of the string input to be added to list
   */
  inputValue: PropTypes.string.isRequired,
  /**
   * list of values added
   */
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Function executed onChange of input value with params - (event, value, type)
   */
  onInputChange: PropTypes.func.isRequired,
  disableClearable: PropTypes.bool,
  /**
   * Function executed when a value is added to list of values - (updatedList, inputvalue)
   */
  onAddValue: PropTypes.func.isRequired,
  /**
   * Function executed when a value is added to list of values - (updatedList, inputvalue)
   */
  onDeleteValue: PropTypes.func.isRequired,
  /**
   * Function executed when a value is added to list of values - (updatedList, inputvalue)
   */
  onClear: PropTypes.func,
};

export default ChipInput;
